import { CORE_API_HOST, DATA_WAREHOUSE_API_HOST } from '../utils/api-hosts';

export default {
  data_warehouse: {
    url: '',
    baseURL: CORE_API_HOST,
    methods: {
      getDWConfig: req => ({
        url: `organizations/${req.organization_id}/data-warehouse`,
        ...(req.query && { params: req.query }),
        ...(req.headers && { headers: req.headers }),
        method: 'GET',
        toast: false,
        signal: req.signal,
      }),
      toggleOrganizationDW: req => ({
        url: `organizations/${req.organization_id}/data-warehouse`,
        ...(req.query && { params: req.query }),
        ...(req.headers && { headers: req.headers }),
        method: 'POST',
        data: req.body,
        toast: false,
        signal: req.signal,
      }),
      toggleAssetDW: req => ({
        url: `assets/${req.asset_id}/data-warehouse`,
        ...(req.query && { params: req.query }),
        ...(req.headers && { headers: req.headers }),
        method: 'POST',
        data: req.body,
        toast: false,
        signal: req.signal,
      }),
      getOrganizationDWUrl: req => ({
        url: `organizations/${req.organization_id}/data-warehouse/credentials`,
        ...(req.query && { params: req.query }),
        ...(req.headers && { headers: req.headers }),
        method: 'GET',
        toast: false,
        signal: req.signal,
      }),
      getAssetDWUrl: req => ({
        url: `assets/${req.asset_id}/data-warehouse/credentials`,
        ...(req.query && { params: req.query }),
        ...(req.headers && { headers: req.headers }),
        method: 'GET',
        toast: false,
        signal: req.signal,
      }),
      getRegions: req => ({
        url: `organizations/${req.organization_id}/data-warehouse/regions`,
        ...(req.query && { params: req.query }),
        ...(req.headers && { headers: req.headers }),
        method: 'GET',
        toast: false,
        signal: req.signal,
      }),
      // DATA_WAREHOUSE manual sync apis
      getSyncStatus: req => ({
        baseURL: DATA_WAREHOUSE_API_HOST,
        url: `sync-status`,
        ...(req.query && { params: req.query }),
        ...(req.headers && { headers: req.headers }),
        method: 'GET',
        toast: false,
        signal: req.signal,
      }),
      sync: req => ({
        baseURL: DATA_WAREHOUSE_API_HOST,
        url: `sync`,
        ...(req.query && { params: req.query }),
        ...(req.headers && { headers: req.headers }),
        method: 'POST',
        data: req.body,
        toast: false,
        signal: req.signal,
      }),

      // Custom datasets APIs
      createCustomDataset: req => ({
        url: `custom-datasets/`,
        ...(req.query && { params: req.query }),
        ...(req.headers && { headers: req.headers }),
        baseURL: DATA_WAREHOUSE_API_HOST,
        method: 'POST',
        data: req.body,
        toast: false,
        signal: req.signal,
      }),
      updateCustomDataset: req => ({
        url: `custom-datasets/${req.dataset_id}`,
        ...(req.query && { params: req.query }),
        ...(req.headers && { headers: req.headers }),
        baseURL: DATA_WAREHOUSE_API_HOST,
        method: 'PUT',
        data: req.body,
        toast: false,
        signal: req.signal,
      }),
      deleteCustomDataset: req => ({
        url: `custom-datasets/${req.dataset_id}/`,
        ...(req.query && { params: req.query }),
        ...(req.headers && { headers: req.headers }),
        baseURL: DATA_WAREHOUSE_API_HOST,
        method: 'DELETE',
        toast: false,
        signal: req.signal,
      }),
      getCustomDataset: req => ({
        url: `custom-datasets/${req.dataset_id}/`,
        ...(req.query && { params: req.query }),
        ...(req.headers && { headers: req.headers }),
        baseURL: DATA_WAREHOUSE_API_HOST,
        method: 'GET',
        toast: false,
        signal: req.signal,
      }),
      getCustomDatasets: req => ({
        url: `custom-datasets/`,
        ...(req.query && { params: req.query }),
        ...(req.headers && { headers: req.headers }),
        baseURL: DATA_WAREHOUSE_API_HOST,
        method: 'GET',
        toast: false,
        signal: req.signal,
      }),
    },
  },
};
